/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaveunsavedbody2Inputs */

const en_leaveunsavedbody2 = /** @type {(inputs: Leaveunsavedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your changes are not saved yet and will be lost.`)
};

const de_leaveunsavedbody2 = /** @type {(inputs: Leaveunsavedbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Änderungen sind noch nicht gespeichert und gehen verloren.`)
};

/**
* | output |
* | --- |
* | "Your changes are not saved yet and will be lost." |
*
* @param {Leaveunsavedbody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const leaveunsavedbody2 = /** @type {((inputs?: Leaveunsavedbody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaveunsavedbody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leaveunsavedbody2(inputs)
	return de_leaveunsavedbody2(inputs)
});
export { leaveunsavedbody2 as "leaveUnsavedBody" }